import { render } from "./ProviderLabel2FA.vue?vue&type=template&id=7dfcbad2&scoped=true"
import script from "./ProviderLabel2FA.vue?vue&type=script&lang=js"
export * from "./ProviderLabel2FA.vue?vue&type=script&lang=js"

import "./ProviderLabel2FA.vue?vue&type=style&index=0&id=7dfcbad2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfcbad2"]])

export default __exports__